// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/aivowebsite.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-4 {
    padding-left: 5%;
    padding-right: 5%;
}

.container-2 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.left-2 {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.right-2 {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.main-4 {
    font-family: sans-serif;
    font-size: 6em;
    line-height: 46px;
    letter-spacing: 0;
    font-weight: 700;
}
.grid-container-4 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    gap: 30px;
}

.box-4 {
    background-color: white;
    border: 1px solid #009fe3;
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    font-weight: bolder;
}
.box-4:hover {
    background-color: yellow;
  }

.container-style {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: "center"
}

@media screen and (max-width: 1000px) {
    .main-container-4{
        padding-left: 10px;
        padding-right: 10px;
    }
    .container-2 {
        flex-direction: column;
    }

    .main-container {
        padding: 0;
    }

    .left-2 {
        width: 100%;
        margin-top: 30px;
    }

    .right-2 {
        width: 100%;
        align-items: center;
    }

}
@media (max-width: 600px) {
    .grid-container-4{
        grid-template-columns: 4fr;
    }
}`, "",{"version":3,"sources":["webpack://./src/Home/Four.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,kCAAkC;IAClC,uCAAuC;IACvC,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,wBAAwB;EAC1B;;AAEF;IACI,yDAAkD;IAClD,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;AAEJ;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".main-container-4 {\n    padding-left: 5%;\n    padding-right: 5%;\n}\n\n.container-2 {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n}\n\n.left-2 {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.right-2 {\n    width: 50%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.main-4 {\n    font-family: sans-serif;\n    font-size: 6em;\n    line-height: 46px;\n    letter-spacing: 0;\n    font-weight: 700;\n}\n.grid-container-4 {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-rows: auto auto auto auto;\n    gap: 30px;\n}\n\n.box-4 {\n    background-color: white;\n    border: 1px solid #009fe3;\n    border-radius: 10px;\n    padding: 20px;\n    text-align: center;\n    font-weight: bolder;\n}\n.box-4:hover {\n    background-color: yellow;\n  }\n\n.container-style {\n    background-image: url(\"../Images/aivowebsite.png\");\n    background-size: cover;\n    background-position: \"center\"\n}\n\n@media screen and (max-width: 1000px) {\n    .main-container-4{\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n    .container-2 {\n        flex-direction: column;\n    }\n\n    .main-container {\n        padding: 0;\n    }\n\n    .left-2 {\n        width: 100%;\n        margin-top: 30px;\n    }\n\n    .right-2 {\n        width: 100%;\n        align-items: center;\n    }\n\n}\n@media (max-width: 600px) {\n    .grid-container-4{\n        grid-template-columns: 4fr;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
